// Generated by CoffeeScript 1.12.6
(function() {
  var getId, id;

  id = 0;

  getId = function() {
    return id++;
  };

  module.exports = {
    mixins: [require("ceri/lib/structure"), require("ceri/lib/props"), require("ceri/lib/style"), require("ceri/lib/getViewportSize"), require("ceri/lib/c-for"), require("ceri/lib/events")],
    structure: function(){return [this.el("c-for",{"names":{"":"toast"},"id":{"":"id"},"iterate":{"":"toasts"}},function(){return [this.el("ceri-toast",{"toast":{"$":"toast"}},[])]})]}



,
    props: {
      zIndex: {
        type: Number,
        "default": 10000
      },
      timeout: {
        type: Number,
        "default": 2500
      }
    },
    events: {
      resize: {
        window: {
          el: window,
          throttled: true,
          destroy: true,
          cbs: function() {
            return this.$watch.notify("isTop");
          }
        }
      }
    },
    data: function() {
      return {
        toasts: []
      };
    },
    computedStyle: {
      "this": function() {
        return {
          zIndex: this.zIndex
        };
      }
    },
    computed: {
      isTop: function() {
        var pos, vpheight;
        pos = this.getBoundingClientRect();
        vpheight = this.getViewportSize().height;
        return pos.top + pos.height / 2 <= vpheight / 2;
      }
    },
    methods: {
      clear: function() {
        return this.toasts = [];
      },
      toast: function(o) {
        if (o.timeout == null) {
          o.timeout = this.timeout;
        }
        if (o.zIndex == null) {
          o.zIndex = this.zIndex;
        }
        o.id = getId();
        o.close = (function(_this) {
          return function(instant) {
            var remove;
            o.removeTimeout();
            remove = function() {
              var index;
              if (~(index = _this.toasts.indexOf(o))) {
                _this.toasts.splice(index, 1);
                return _this.$watch.notify("toasts");
              }
            };
            if (instant) {
              remove();
              return typeof o.onClose === "function" ? o.onClose() : void 0;
            } else {
              return o._close(remove);
            }
          };
        })(this);
        o.setTimeout = function() {
          var timeoutObj;
          if (typeof o.removeTimeout === "function") {
            o.removeTimeout();
          }
          if (o.timeout) {
            timeoutObj = setTimeout(o.close, o.timeout);
          }
          return o.removeTimeout = function() {
            if (timeoutObj != null) {
              clearTimeout(timeoutObj);
              return timeoutObj = null;
            }
          };
        };
        o.setTimeout();
        if (this.isTop) {
          this.toasts.push(o);
        } else {
          this.toasts.unshift(o);
        }
        this.$watch.notify("toasts");
        return o;
      }
    }
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-toaster/toaster-component.js
// module id = 66
// module chunks = 1